import { Link } from "wouter";
import { useLanguage } from "@/contexts/LanguageContext";
import logoWrkt from "@assets/Wrkt_-_PNG_1771840403931.png";

export default function Footer() {
  const { t, localePath } = useLanguage();

  return (
    <footer aria-label="Site footer" className="bg-[#0A1F14] border-t border-white/10 pt-16 pb-8 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[radial-gradient(ellipse_at_bottom,rgba(37,108,67,0.15),transparent_70%)] pointer-events-none"></div>
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6 col-span-1 md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={logoWrkt} alt="Wrkt Digital logo" width={656} height={657} loading="lazy" decoding="async" className="h-10 w-auto object-contain" />
              <span className="font-display font-extrabold text-[19px] tracking-[-0.02em] text-white">wrkt <span className="text-[#4BF4B9]">digital</span></span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed">{t("footer_desc")}</p>
            
            <div className="pt-6 border-t border-white/10 mt-6">
              <p className="text-xs font-semibold text-white/50 uppercase tracking-widest mb-4">{t("footer_partners")}</p>
              <div className="flex gap-3 items-stretch flex-wrap">
                {[
                  { name: 'Meta', sub: 'Business Partner' },
                  { name: 'TikTok', sub: 'Smart+ Partner' },
                  { name: 'Google Ads', sub: 'Partner' },
                  { name: 'Klaviyo', sub: 'Partner' },
                  { name: 'OpenAI', sub: 'Enterprise' },
                ].map((p) => (
                  <div key={p.name} className="px-[18px] py-3 border border-white/[0.12] rounded-xl bg-white/[0.03] flex flex-col gap-0.5 hover:border-white/[0.24] transition-colors duration-300">
                    <span className="font-display font-bold text-[13px] text-white/85">{p.name}</span>
                    <span className="text-[8px] font-semibold uppercase tracking-[0.16em] text-white/45">{p.sub}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="space-y-4 md:pt-4">
            <h4 className="font-bold font-display text-lg mb-6">{t("footer_contact")}</h4>
            <a href="mailto:contact@wrkt.nl" className="block text-white/60 hover:text-[#4CEAAC] transition-colors">contact@wrkt.nl</a>
            <a href="tel:+310208965136" className="block text-white/60 hover:text-[#4CEAAC] transition-colors">+31 (0)20 896 51 36</a>
            <div className="text-white/60 pt-4">
              Herengracht 372<br />
              1016 CH Amsterdam
            </div>
          </div>
          
          <div className="space-y-4 md:pt-4">
            <h4 className="font-bold font-display text-lg mb-6">{t("footer_links")}</h4>
            <Link href={localePath("/cases")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t('footer_cases')}</Link>
            <Link href={localePath("/about")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t('nav_about')}</Link>
            <Link href={localePath("/werkwijze")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t('nav_method')}</Link>
            <Link href={localePath("/signal")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t("nav_signal")}</Link>
            <Link href={localePath("/artikelen")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t("nav_articles")}</Link>
            <Link href={localePath("/contact")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors">{t("footer_contact")}</Link>
            <a href="https://www.linkedin.com/company/wrktdigital?originalSubdomain=nl" target="_blank" rel="noopener noreferrer" className="block text-white/60 hover:text-[#4CEAAC] transition-colors">LinkedIn</a>
            <a href="https://www.instagram.com/wrktdigital/" target="_blank" rel="noopener noreferrer" className="block text-white/60 hover:text-[#4CEAAC] transition-colors">Instagram</a>
            <Link href={localePath("/privacy")} className="block text-white/60 hover:text-[#4CEAAC] transition-colors mt-4">{t("footer_privacy")}</Link>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8 flex justify-center items-center">
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} Wrkt Digital BV. {t("footer_rights")}</p>
        </div>
      </div>
    </footer>
  );
}
